export function buildRedirectDetails(redirectResult: string) {
  return {
    details: {
      redirectResult,
    },
  };
}
